import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en.json";
import translationDE from "./locales/de.json";
import translationAr from "./locales/ar.json";
import translationIT from "./locales/it.json";
import translationFR from "./locales/fr.json";
import translationNL from "./locales/nl.json";
import translationRO from "./locales/ro.json";
import translationPT from "./locales/pt.json";
import translationSV from "./locales/sv.json";
import translationPL from "./locales/pl.json";
import { handleLang } from "./utils/helpers";

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
  ar: { translation: translationAr },
  it: { translation: translationIT },
  fr: { translation: translationFR },
  nl: { translation: translationNL },
  ro: { translation: translationRO },
  pt: { translation: translationPT },
  sv: { translation: translationSV },
  pl: { translation: translationPL },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "de",
    fallbackLng: "de",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

i18n.on("languageChanged", (lng) => handleLang(lng));

export default i18n;
